import React, { useState } from 'react'
import {
    makeStyles, Box, Button, Card, CardHeader, CardContent, Collapse, Typography, Grid
} from '@material-ui/core'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import { productCategoryMap } from 'config/constants/Constants'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { NotificationManager } from 'react-notifications'
import TechnologyCategorySection, { cleanTechnology } from 'components/provider/TechnologyCategorySection'

const useStyles = makeStyles(componentStyles)

// Technology/brand profile card for a single product (e.g. EV Charger, Heat
// Pump), mirroring the solar TechnologyCard. Each technology category the
// product covers supports multiple entries.
function ProductCard(props) {
    const classes = { ...useStyles() }
    const [open, setOpen] = useState(true)
    const api = new ProviderAPI()

    const product = props.product
    const companyId = props.companyId
    const company = props.companyDetails || {}
    const brands = props.brands || []

    const categories = productCategoryMap[product] || []

    const [loading, setLoading] = useState(false)

    async function saveDetails() {
        setLoading(true)
        try {
            const updatedCompany = await api.updateTechnology(companyId, cleanTechnology(company.technology || {}))
            props.updateCompany(updatedCompany)
            NotificationManager.success(`${product} details saved`)
        } catch (e) {
            onError(e)
        }
        setLoading(false)
    }

    return (
        <Card>
            <CardHeader
                subheader={
                    <Box display='flex' style={{ justifyContent: 'space-between' }}>
                        <Box>
                            <Box component={Typography} variant='h2' marginBottom='0!important'>
                                <Box component='span'>{product}</Box>
                            </Box>
                            <Box
                                component='p'
                                fontSize='.875rem'
                                marginBottom='0'
                                marginTop='0'
                                lineHeight='1.7'
                                fontWeight='300'
                            >
                                Tell customers about your {product.toLowerCase()} offering. Add multiple entries per category if you offer more than one. Leave any sections that are not applicable blank.
                            </Box>
                        </Box>
                    </Box>
                }
                onClick={() => setOpen(o => !o)}
                style={{ cursor: 'pointer' }}
                action={<ExpandMoreIcon style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s', marginTop: 4 }} />}
                classes={{ root: classes.cardHeaderRoot }}
            ></CardHeader>

            <Collapse in={open}>
                <CardContent>
                    <Grid container spacing={3}>
                        {categories.map(cat => (
                            <TechnologyCategorySection
                                key={cat}
                                cat={cat}
                                companyId={companyId}
                                brands={brands}
                                technology={company.technology || {}}
                                updateField={props.updateField}
                            />
                        ))}

                        <Grid item xs={12}>
                            <Box display='flex' justifyContent='flex-end'>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={saveDetails}
                                    disabled={loading}
                                >
                                    {loading ? 'Saving...' : `Save ${product}`}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Collapse>
        </Card>
    )
}

export default ProductCard
